var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounForm652663(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.479,41.583H43.354c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h13.125c0.276,0,0.5-0.224,0.5-0.5   S56.756,41.583,56.479,41.583z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.479,47.484H43.354c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h13.125c0.276,0,0.5-0.224,0.5-0.5   S56.756,47.484,56.479,47.484z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.479,50.344H43.354c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h13.125c0.276,0,0.5-0.224,0.5-0.5   S56.756,50.344,56.479,50.344z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.479,44.438H43.354c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h13.125c0.276,0,0.5-0.224,0.5-0.5   S56.756,44.438,56.479,44.438z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50,14.599c-20.054,0-36.31,16.256-36.31,36.312c0,20.055,16.256,36.311,36.31,36.311   c20.055,0,36.311-16.256,36.311-36.311C86.311,30.854,70.055,14.599,50,14.599z M60.75,62.417c0,1.104-0.896,2-2,2h-17.5   c-1.104,0-2-0.896-2-2V37.583c0-1.104,0.896-2,2-2h17.5c1.104,0,2,0.896,2,2V62.417z M73.62,41.666l-7.729,7.728l-3.499,1.376   l1.378-3.497l7.729-7.728c0.586-0.586,1.535-0.586,2.121,0S74.206,41.08,73.62,41.666z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounForm652663);
export default __webpack_public_path__ + "static/media/noun_form_652663.28c43ef1.svg";
export { ForwardRef as ReactComponent };